import { MessageType } from "./tab-socket/message-type";
import { StatusMessageInterface } from "./tab-socket/status-message.interface";
import { TabSocket } from "./tab-socket/tab-socket";

export class TabMessagesHelper {

  /**
  * Check if there are pending changes in the iframe
  * @returns Promise with boolean indicating pending changes
  */
  static async checkPendingChanges(tabSocket: TabSocket, timeout = 5000): Promise<boolean> {
    if (!tabSocket) {
      return false;
    }

    const lastStatus = tabSocket.onStatusPush().value;
    if (lastStatus) {
      return lastStatus.pendingChanges;
    }

    try {
      return await tabSocket.sendMessageAsync<string, boolean>('check-pending-changes', MessageType.AskPendingChanges, timeout = 5000);
    } catch (err) {
      console.error('Error checking iframe pending changes:', err);
      return false;
    }
  }

  /**
   * Check the current status from the iframe
   * @returns Promise with status data
   */
  static async checkStatus(tabSocket: TabSocket, timeout = 5000): Promise<StatusMessageInterface> {
    if (!tabSocket) {
      return {
        hasModalOpen: false,
        pendingChanges: false,
        version: 0
      };
    }

    const lastStatus = tabSocket.onStatusPush().value;
    if (lastStatus) {
      return lastStatus;
    }

    try {
      return await tabSocket.sendMessageAsync<string, StatusMessageInterface>('check-status', MessageType.AskStatus, timeout = 5000);
    } catch (err) {
      console.error('Error checking iframe status:', err);
      return {
        hasModalOpen: false,
        pendingChanges: false,
        version: 0
      };
    }
  }
}
